// @vue/component
import axios from 'axios';
import dateFormatter from '../i18n/dateFormatter';
import HandlesErrorResponses from './HandlesErrorResponses';
import modalManager from '../services/modalManager';
import CovCheckResultModal from '../components/CovCheckResultModal.vue';

export default {
    mixins: [
        HandlesErrorResponses,
    ],

    methods: {
        async doCovCheck(patientId, date, showPoliciesLink) {
            let response = null;

            try {
                response = (await axios.post(`/patient/${patientId}/policies/cov_check`,
                    { date: date || dateFormatter(new Date()) }
                )).data;
            } catch (error) {
                return this.handleErrorResponse(error);
            }

            return modalManager.openComponentInModal(CovCheckResultModal,
                {
                    showPoliciesLink,
                    ...response.data,
                },
                {},
                'small'
            );
        },
    },
};
